module.exports = __webpack_public_path__ + "elephant_ui_disappointed-8864342480c3612e3061702851d3a798.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/elephant_ui_disappointed.svg
// module id = 254
// module chunks = 70